module.exports = __webpack_public_path__ + "img/slide-23.7aa12318.jpg";